/** P336 -- supervisory-checks hook (the SAMA field-examiner's questions). */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { SupervisoryChecks } from "shared/api/types";

export const fieldExamKeys = {
  read: ["twin", "supervisory-checks"] as const,
};

export function useSupervisoryChecks(): UseQueryResult<SupervisoryChecks, ApiError> {
  return useQuery({
    queryKey: fieldExamKeys.read,
    queryFn: () => api.get<SupervisoryChecks>("/v1/twin/supervisory-checks"),
  });
}
